export default __webpack_public_path__ + "static/media/Parallax-HUD-Flight Indicator.82534b42.jpg";